module.exports = {
	nav: {
		home: '首頁',						// 首页
		about: '關於我們',					// 关于我们
		project: '項目實景',					// 项目实景
		contact: '聯系我們',				// 联系我们
		language: '語言',			// 语言选择
	},
	content: {
		// 2021/11/12 内容区 要首字母大写
		about: '關於我們',					// 关于我们
		contact: '聯系我們',				// 联系我们
	},
	contact: {
		xing: '姓',		// 姓
		name: '名',		// 名
		email: '郵箱',		// 邮箱
		address: '位址',	// 住址
		zhushi: '意見',		// 意見
		submit: '提交',		// 提交
		bitian: '必填項',	// 必填项必填項
		
		inputXing: '请输入您的姓氏(繁)',			// 请输入您的姓氏
		inputName: '请输入您的名字(繁)',			// 请输入您的名字
		inputZqEmail: '請輸入有效的郵箱號',	// 請輸入有效的郵箱號
		
	}
}